<template>
  <div id="ready-release">
    <div style="width: 100%;">
      <Breadcrumb></Breadcrumb>
      <el-form
        :model="queryParams"
        ref="form"
        id="form"
        class="form-body"
        label-width="80px"
        style="margin-top: 10px"
      >
        <el-row :gutter="20">
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="产品编号：">
                <el-input
                  size="small"
                  v-model="queryParams.pId"
                  placeholder="请输入产品编号"
                ></el-input>
              </el-form-item></div
          ></el-col>
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="产品名称：">
                <el-input
                  size="small"
                  v-model="queryParams.proName"
                  placeholder="请输入产品名称"
                ></el-input>
              </el-form-item></div
          ></el-col>

          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="创建时间：">
                <el-date-picker
                  size="small"
                  v-model="queryParams.time"
                  style="width: 100%;"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item></div
          ></el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col v-if="false" :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="汇出店铺：">
                <el-select
                  clearable
                  v-model="queryParams.shopId"
                  placeholder="请选择店铺名称"
                  size="small"
                  style="width:100%"
                >
                  <el-option
                    v-for="(record, index) in shopList"
                    :key="index"
                    :label="record.shopName"
                    :value="record.shopId"
                  >
                  </el-option>
                </el-select>
              </el-form-item></div
          ></el-col>
          <el-col :span="8"
            ><div class="grid-content bg-purple">
              <el-form-item label="是否汇出：">
                <el-select
                  clearable
                  v-model="queryParams.remitFlag"
                  placeholder="请选择是否汇出"
                  size="small"
                  style="width:100%"
                >
                  <el-option label="是" value="1"> </el-option>
                  <el-option label="否" value="0"> </el-option>
                </el-select>
              </el-form-item></div
          ></el-col>
          <el-col :span="16"
            ><div class="grid-content bg-purple" style="text-align:right;">
              <el-button size="small" type="primary" @click="getList"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </div></el-col
          >
        </el-row>
      </el-form>
    </div>

    <div class="table-body">
      <div style="padding-bottom: 10px;display: inline-block;width: 100%">
        <div style="float: left">
          <el-button
            type="primary"
            size="small"
            @click="handleJumpCreateProduct"
            >创建产品</el-button
          >
          <el-button @click="handleExport" type="primary" size="small"
            >汇出</el-button
          >
        </div>
        <div style="float: right">
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :page-size="queryParams.pageSize"
            :page-sizes="[100, 200, 300, 400]"
            @pagination="getList"
          />
        </div>
      </div>
      <el-table
        id="outTable"
        ref="multipleTable"
        :data="tableData"
        header-cell-class-name="table-header"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column width="170" prop="pId" label="产品编号" align="center">
        </el-table-column>
        <el-table-column prop="mainPic" label="产品信息" align="left">
          <template slot-scope="scope">
            <el-popover
              style="float:left;"
              placement="right"
              width="300"
              trigger="hover"
            >
              <img
                class="img-big"
                :src="scope.row.mainPic ? scope.row.mainPic : noImage"
                style="width: 300px;height: 300px"
              />
              <img
                slot="reference"
                class="img-small"
                :src="scope.row.mainPic ? scope.row.mainPic : noImage"
              />
            </el-popover>
            <div style="float:left;width:200px;margin: 8px 0 0 8px;">
              <a
                v-if="scope.row.dataUrl"
                :target="scope.row.dataUrl ? '_blank' : ''"
                :href="
                  scope.row.dataUrl ? scope.row.dataUrl : 'javascript:void(0)'
                "
                style="color:#409eff;"
                >{{ scope.row.proName }}</a
              >
              <span v-else>{{ scope.row.proName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="汇出店铺" prop="shopName" align="center">
        </el-table-column>
        <el-table-column
          label="是否汇出"
          prop="remitFlag"
          align="center"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.remitFlag == "1" ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="160"
          prop="createTime"
          label="创建时间"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime }}
          </template>
        </el-table-column>
        <el-table-column
          width="140px"
          prop="handel"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="editRow(scope.row)"
              >编辑</el-button
            >
            <el-button type="text" size="mini" @click="handleCopy(scope.row)"
              >复制</el-button
            >
            <el-button type="text" size="mini" @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb';
import { mapGetters } from "vuex"
import {getProductList,copyProduct,deleteProduct, addRemit} from '@/api/product/amazon';
import {getTree} from '@/api/tree/tree';
import { getShopList } from "@/api/system/shopManage"
import TreeSelect from '@/components/common/treeSelect';
import { getProductTypeList } from "@/api/plat/platType";
import noImage from '@/assets/images/no_image.png'

export default {
    name: "readyRelease",
    components:{Breadcrumb, TreeSelect},
    data() {
        return {
            loading:false,
            total: 0,
            queryParams: {
              pageNum: 1,
              pageSize: 10,
              pId: "",
              beginTime: null,
              endTime: null,
              time: [],
              proName: "",
              pubStatus: '02',
              shopId: "",
              remitFlag: "",
              platId: ''
            },
            noImage: noImage,
            dateValue:null,
            productTypeList: [],
            treeSelectProps: {
              value:'platId',             // ID字段名
              label: 'platName',         // 显示名称
              children: 'childrenTree'    // 子级字段名
            },
            shopList: [],
            pIds: [],
            products: []
        }
    },
    created() {
      let curDate = new Date()
      let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)
      this.queryParams.time = [this.parseTime(preDate, "{y}-{m}-{d}") , this.parseTime(curDate,"{y}-{m}-{d}")]
      this.getList();
      this.getShopData()
      this.getProductTypeTree()
    },
    computed:{
        ...mapGetters(["dictData", "dictMap"]),
    },
    watch:{
    },
    methods: {
      getTreeNodeId(value){
        this.queryParams.platId = value
      },
       getShopData() {
        getShopList({ platNo: "04" }).then((res) => {
          this.shopList = res.rows
        })
      },
      async getProductTypeTree() {
        let result = await getProductTypeList();
        this.productTypeList = result.data;
      },
      handleJumpCreateProduct(){
        this.$router.push({
          path: '/product/amazon/createProduct'
        })
      },
      //编辑产品
      editRow(row) {
        this.$router.push({
          path: "/product/amazon/createProduct",
          query: { pId: row.pId, type: "2" },
        })
      },
      async handleCopy(row){
         this.$router.push({
          path: "/product/amazon/createProduct",
          query: { pId: row.pId, type: "2" , action: 'new'},
        })
      },
      async handleDelete(row){
        this.$confirm('确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          await deleteProduct(row.pId)
          this.getList()
        });

      },
      handleSelectionChange(val){
        this.pIds = [];
        this.products = []
        val.forEach(r =>{
            this.pIds.push(r.pId)
            this.products.push(r.proName)
        });
      },
      getList() {
        this.startLoading()
        if (this.queryParams.time) {
          this.queryParams.beginTime = this.queryParams.time[0]
          this.queryParams.endTime = this.queryParams.time[1]
        } else {
          this.queryParams.beginTime = undefined
          this.queryParams.endTime = undefined
        }
        let params = Object.assign({}, this.queryParams)
        delete params["time"]

        getProductList(params)
          .then((res) => {
            res.rows.map((record) => {
              record.expand = false
            })
            this.tableData = res.rows
            this.total = res.total
            this.endLoading()
          })
          .catch((err) => {
            this.endLoading()
            console.log(err)
        })
      },
      async handleExport(){
        if(this.pIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
        }
        // this.$confirm('确定是否汇出？', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(async () => {
        //   await addRemit({pId : this.pIds.join(',')})
        //   this.$message.success("操作成功！")
        //   this.getList()
        // });
         if(this.pIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
        } 
        this.$router.push(`/carry/proCustom/createTemplateData?pId=${this.pIds.join(',')}&name=${this.products.join(',')}`)
      },resetForm(){
        this.queryParams =  {
              pageNum: 1,
              pageSize: 10,
              pId: "",
              beginTime: null,
              endTime: null,
              time: [],
              proName: "",
              pubStatus: '02',
              shopId: "",
              remitFlag: "",
              platId: ''
            }
      }
    },
    mounted() {

    }
}
</script>

<style scoped>
@import "../../../assets/css/product.css";
#ready-release {
  width: 100%;
}
.detailForm {
  padding-top: 5px;
  margin-left: 85px;
  width: 50%;
  height: auto;
  margin-bottom: 8px;
}
.detailForm .el-form-item,
.sea_cont {
  margin-bottom: 10px !important;
}
.double_item .el-form-item {
  margin-bottom: 0px !important;
}
.scro >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
.rightarea {
  float: left;
  width: 100%;
}
.btn {
  background: rgb(239, 239, 239);
  color: #000000;
  border: none;
}
.btn:hover {
  color: #2689ed;
}
.amazon_rel_tab .el-table .el-table__body-wrapper {
  font-size: 13px !important;
}
.img-small {
  width: 100px;
  height: 100px;
}
</style>
